"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _People = _interopRequireDefault(require("@insided/destination/icons/People"));

var _Computer = _interopRequireDefault(require("@insided/destination/icons/Computer"));

var _Clock = _interopRequireDefault(require("@insided/destination/icons/Clock"));

var _Location = _interopRequireDefault(require("@insided/destination/icons/Location"));

var _Link = _interopRequireDefault(require("@insided/destination/icons/Link"));

var _CalendarLinks = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/CalendarLinks"));

var EventDetails = function EventDetails(_ref) {
  var scheduleAt = _ref.scheduleAt,
      location = _ref.location,
      link = _ref.link,
      linkLabel = _ref.linkLabel,
      group = _ref.group,
      attachmentCdn = _ref.attachmentCdn,
      appleCalendarICSDownloader = _ref.appleCalendarICSDownloader,
      googleCalendarLink = _ref.googleCalendarLink,
      outlookCalendarLink = _ref.outlookCalendarLink,
      office365CalendarLink = _ref.office365CalendarLink,
      isPastEvent = _ref.isPastEvent;
  var groupThumbImage = group !== null && group !== void 0 && group.thumbnailImage ? "".concat(attachmentCdn).concat(group === null || group === void 0 ? void 0 : group.thumbnailImage) : null;
  var groupTypeLabel = group !== null && group !== void 0 && group.isPrivate ? (0, _preact.h)(_phrase.default, {
    p: "events.private.group",
    m: "Forum"
  }) : null;
  return (0, _preact.h)("div", {
    className: "event-details-wrapper"
  }, (group === null || group === void 0 ? void 0 : group.isPrivate) && (0, _preact.h)("div", {
    className: "event-details-container"
  }, (0, _preact.h)("a", {
    className: "event-group-url",
    href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/groups/").concat(group === null || group === void 0 ? void 0 : group.id))
  }, (0, _preact.h)("div", {
    className: "event-group-detail-row"
  }, groupThumbImage && (0, _preact.h)("div", {
    className: "event-group-thumbnail"
  }, (0, _preact.h)("div", {
    className: "event-group-thumbnail__image",
    style: {
      backgroundImage: "url(".concat(groupThumbImage, ")")
    }
  })), (0, _preact.h)("div", {
    className: "event-group-details"
  }, (0, _preact.h)("div", {
    className: "event-group__title"
  }, group === null || group === void 0 ? void 0 : group.title), (0, _preact.h)("div", {
    className: "event-group__type"
  }, groupTypeLabel))))), (0, _preact.h)("div", {
    className: "event-details-container"
  }, (0, _preact.h)("div", {
    className: "event-details__header_label"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.details",
    m: "Forum"
  })), location ? (0, _preact.h)("div", {
    className: "event-detail-row"
  }, (0, _preact.h)("div", {
    className: "event-detail-icon"
  }, (0, _preact.h)(_People.default, null)), (0, _preact.h)("div", {
    className: "event-detail-info"
  }, (0, _preact.h)("div", {
    className: "event-detail__label"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.location.in.person",
    m: "Forum"
  })))) : (0, _preact.h)("div", {
    className: "event-detail-row"
  }, (0, _preact.h)("div", {
    className: "event-detail-icon"
  }, (0, _preact.h)(_Computer.default, null)), (0, _preact.h)("div", {
    className: "event-detail-info"
  }, (0, _preact.h)("div", {
    className: "event-detail__label"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.location.online",
    m: "Forum"
  })))), (0, _preact.h)("div", {
    className: "event-detail-row"
  }, (0, _preact.h)("div", {
    className: "event-detail-icon"
  }, (0, _preact.h)(_Clock.default, null)), (0, _preact.h)("div", {
    className: "event-detail-info"
  }, (0, _preact.h)("div", {
    className: "event-detail__label"
  }, scheduleAt))), location && (0, _preact.h)("div", {
    className: "event-detail-row"
  }, (0, _preact.h)("div", {
    className: "event-detail-icon"
  }, (0, _preact.h)(_Location.default, null)), (0, _preact.h)("div", {
    className: "event-detail-info"
  }, (0, _preact.h)("div", {
    className: "event-detail__label"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.location",
    m: "Forum"
  })), (0, _preact.h)("div", null, location))), link && (0, _preact.h)("div", {
    className: "event-detail-row"
  }, (0, _preact.h)("div", {
    className: "event-detail-icon"
  }, (0, _preact.h)(_Link.default, null)), (0, _preact.h)("div", {
    className: "event-detail-info"
  }, (0, _preact.h)("div", {
    className: "event-detail__label"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.link",
    m: "Forum"
  })), (0, _preact.h)("a", {
    className: "event-detail__link event-detail__text",
    href: (0, _absoluteUrlRuntime.resolveUrl)(link),
    target: "_blank",
    rel: "noreferrer"
  }, linkLabel)))), !isPastEvent && (0, _preact.h)(_CalendarLinks.default, {
    googleCalendarLink: googleCalendarLink,
    outlookCalendarLink: outlookCalendarLink,
    office365CalendarLink: office365CalendarLink,
    appleCalendarICSDownloader: appleCalendarICSDownloader
  }));
};

var _default = EventDetails;
exports.default = _default;